import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { emptyArray } from 'ui-components/default-props/empty';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../hooks/entities/selectors/fulfillment-plans';
import { createDeleteItemColumnDefinition, DeleteItemColumnId, deleteItemDataBuilder } from '../../edit-items-table/columns/delete-item';

import {
  createEditItemNameColumnDefinition,
  EditItemNameColumnId,
  editItemNameDataBuilder,
} from '../../edit-items-table/columns/edit-item-name';

import {
  createEditItemQuantityColumnDefinition,
  EditItemQuantityColumnId,
  editItemQuantityDataBuilder,
} from '../../edit-items-table/columns/edit-item-quantity';
import {
  createEditItemSkuColumnDefinition,
  EditItemSkuColumnId,
  editItemSkuDataBuilder,
} from '../../edit-items-table/columns/edit-item-sku';
import {
  createEditItemUnitColumnDefinition,
  EditItemUnitPriceColumnId,
  editItemUnitPriceDataBuilder,
} from '../../edit-items-table/columns/edit-item-unit-price';
import {
  createOrderNumberColumnDefinition,
  OrderNumberColumnId,
  orderNumberDataBuilder,
} from '../../edit-items-table/columns/order-number';

import EditItemsTable from '../../../../../components/items-table/items-table';
import { AddItemButtonRow } from './add-item-button';
import { EditItemsTableEmptyRow } from '../../edit-items-table/empty-row';
import { useEditItemsContext } from '../context';

const useEditItemsTableColumns = (fulfillmentPlanId) => {
  const salesOrdersFulfilledIds = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'salesOrdersFulfilledIds') || emptyArray;
  const fulfillsMultipleSalesOrders = salesOrdersFulfilledIds.length > 1;
  return useMemo(
    () => [
      createEditItemSkuColumnDefinition(),
      createEditItemNameColumnDefinition(),
      createEditItemQuantityColumnDefinition(),
      createEditItemUnitColumnDefinition(),
      ...(fulfillsMultipleSalesOrders ? [createOrderNumberColumnDefinition()] : []),
      createDeleteItemColumnDefinition(),
    ],
    [fulfillsMultipleSalesOrders],
  );
};

// TODO: potentially show section for empty manual order areas
const EditItemsSection = ({ fulfillmentPlanId, salesOrderId }) => {
  const { updateItemProperties, deleteItem, isSaving, displayItems: items } = useEditItemsContext();

  const formattedItems = useMemo(
    () =>
      items.map((item) => {
        return {
          id: item.id,
          [OrderNumberColumnId]: orderNumberDataBuilder(item),
          [EditItemSkuColumnId]: editItemSkuDataBuilder(item),
          [EditItemNameColumnId]: editItemNameDataBuilder(item),
          [EditItemQuantityColumnId]: editItemQuantityDataBuilder(item),
          [EditItemUnitPriceColumnId]: editItemUnitPriceDataBuilder(item),
          [DeleteItemColumnId]: deleteItemDataBuilder(item),
        };
      }),
    [items],
  );

  const columns = useEditItemsTableColumns(fulfillmentPlanId);

  return (
    <div>
      <EditItemsTable
        columns={columns}
        disabled={isSaving}
        emptyRow={<EditItemsTableEmptyRow />}
        items={formattedItems}
        onColumnBlur={updateItemProperties}
        onRowDelete={deleteItem}
      />
      <AddItemButtonRow salesOrderId={salesOrderId} />
    </div>
  );
};

EditItemsSection.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};

export default EditItemsSection;
